/* eslint-disable prettier/prettier */

// @mui material components
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Button from '@mui/material/Button';
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import "rc-tree/assets/index.css"
import Tree,{TreeNode} from "rc-tree";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { InformacionInicialRoles } from 'store/roles/rolesSlice';
import { map, filter, find } from 'lodash';
import Icon from "@mui/material/Icon";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

 function formUsuario({props, onChangeUser}){
    const {rolesUsuarios} = useSelector((state) => state.roles);
    const {nombre, apellioPaterno, apellioMaterno, rolUsuario, correo, celular, username, password, confirmpassword} = props;
       
    //show passwod
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    //show password confirm
    const [showPasswordconfirm, setShowPasswordconfirm] = useState(false);
    const handleClickShowPasswordconfirm = () => setShowPasswordconfirm((show) => !show);
    const handleMouseDownPasswordconfirm = (event) => {
        event.preventDefault();
    };
    const defaultProps = {
        options: rolesUsuarios,
        getOptionLabel: (option) => option.rolUsuario,
    };
    return <>
        <TextField value={nombre} onChange={(event)=>{
                onChangeUser(event.target.value, "nombre");
              }} error={false} helperText={""}  label="Nombre" variant="outlined" style={{width:"100%", marginBottom: "1.5rem"}} size="small"/>
              <TextField value={apellioPaterno} 
              onChange={(event)=>{
                onChangeUser(event.target.value, "apellioPaterno");
              }} error={false} helperText=""  label="Apellido Paterno" variant="outlined" style={{width:"100%", marginBottom: "1.5rem"}} size="small" />
              <TextField value={apellioMaterno} 
              onChange={(event)=>{
                onChangeUser(event.target.value, "apellioMaterno");
              }} error={false} helperText=""  label="Apellido Materno" variant="outlined" style={{width:"100%", marginBottom: "1.5rem"}} size="small"/>
                 <Autocomplete
                    {...defaultProps}
                    id="controlled-demo"
                    value={rolUsuario}
                    onChange={(event, newValue) => {
                     onChangeUser(newValue, "rolUsuario");
                    }}
                    renderInput={(params) => (
                    <TextField {...params} label="Rol" variant="outlined" error={false}  />
                    )}
                    style={{width:"100%", marginBottom: "1rem"}}
                    size="small"

                />
              <TextField value={correo} 
              onChange={(event)=>{
                onChangeUser(event.target.value, "correo");
              }} error={false} helperText=""  label="Correo" variant="outlined" style={{width:"100%", marginBottom: "1.5rem"}} size="small" />
              <TextField value={celular}
              onChange={(event)=>{
                onChangeUser(event.target.value, "celular");
              }} error={false} helperText=""  label="Celular" variant="outlined" style={{width:"100%", marginBottom: "1.5rem"}} size="small" />
              <TextField value={username}
              onChange={(event)=>{
                onChangeUser(event.target.value, "username");
              }} error={false} helperText=""  label="UserName" variant="outlined" style={{width:"100%", marginBottom: "1.5rem"}} size="small" />
              <TextField value={password} type={showPassword ? "text":"password"}
              onChange={(event)=>{
                onChangeUser(event.target.value, "password");
              }} error={false} helperText=""  label="Password" variant="outlined" style={{width:"100%", marginBottom: "1.5rem"}} size="small" 
               
               InputProps={{
                    endAdornment :  <InputAdornment position="end">
                            <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            >
                            {showPassword ? 
                            <Icon fontSize="small" color="secondary">visibility_off</Icon> 
                            : <Icon fontSize="small" color="secondary">visibility</Icon>}
                            </IconButton>
                        </InputAdornment>
                }}
              />
              <TextField value={confirmpassword} type={showPasswordconfirm ? "text":"password"}
              onChange={(event)=>{
                onChangeUser(event.target.value, "confirmpassword");
              }} error={false} helperText=""  label="Confirmar Password" variant="outlined" style={{width:"100%", marginBottom: "1.5rem"}} size="small"
              InputProps={{
                    endAdornment :  <InputAdornment position="end">
                            <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPasswordconfirm}
                            onMouseDown={handleMouseDownPasswordconfirm}
                            edge="end"
                            >
                            {showPasswordconfirm ? 
                            <Icon fontSize="small" color="secondary">visibility_off</Icon> 
                            : <Icon fontSize="small" color="secondary">visibility</Icon>}
                            </IconButton>
                        </InputAdornment>
                }}
              />
    </>
}

formUsuario.defaultProps = {
    props: {}
};

formUsuario.propTypes = {
    props: PropTypes.object.isRequired,
    onChangeUser: PropTypes.func.isRequired
};

export default formUsuario;